<template>
  <div class="page">
    <div class="header">
      <div class="header-content header-play">
        <div class="logo" v-if="isMobile">
          <img src="../assets/images/m/m_logo.png" alt="" />
        </div>
        <!-- 动画效果 -->
        <!-- <div class="header-content" :class="{ 'header-play': isShowHeader, 'header-display': !isShowHeader }"> -->
        <div class="nav" v-if="!isMobile">
          <ul>
            <li>
              <a :class="{ 'nav-active': active_index === 0 }" @click="next(0)">메인</a>
            </li>
            <li>
              <a :class="{ 'nav-active': active_index === 1 }" @click="next(1)">이벤트</a>
            </li>
            <!-- 转盘、达成标记菜单 -->
            <!-- <li @mousemove="showSideNav()" @mouseleave="isShowSubNav = false">
              <a :class="{ 'nav-active': active_index === 2 || active_index === 3 || active_index === 4 }">이벤트</a>
              <div class="sub-nav" v-show="isShowSubNav">
                <div class="sub-nav-item" :class="{ 'nav-active': active_index === 2 }" @click="next(2)">
                  룰렛 이벤트
                </div>
                <div
                  class="sub-nav-item"
                  :class="{ 'nav-active': active_index === 3 || active_index === 4 }"
                  @click="next(3)"
                >
                  달성 이벤트
                </div>
              </div>
            </li> -->
            <li>
              <a :class="{ 'nav-active': active_index === 2 }" @click="next(2)">직업</a>
            </li>
            <li>
              <a :class="{ 'nav-active': active_index === 3 }" @click="next(3)">이미지</a>
            </li>
          </ul>
        </div>
        <div class="others">
          <!-- <div class="home" @click="next(0)" :class="{ 'nav-active': active_index === 0 }" v-if="isMobile">메인</div> -->
          <div class="game" @click="goLink('game')"></div>
          <div class="ytbe" @click="goLink('ytbe')"></div>
          <div class="menus" v-if="isMobile" @click="showMenu">
            <img v-if="!isShowMenu" class="menu" src="../assets/images/m/m_menu.png" alt="" />
            <img v-else class="close" src="../assets/images/m/m_menu_active.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <full-page :options="options" ref="fullpage" id="fullpage">
      <div class="section">
        <div class="bg bg-1">
          <div class="content">
            <div class="content-left">
              <div class="logo" :class="{ 'logo-kf': active_index === 0 }">
                <img src="../assets/images/logo.png" alt="" />
              </div>
              <div id="btn-play" @click="playVideo" :class="{ 'btn-play-kf': active_index === 0 }">
                <img class="circle" src="../assets/images/play_1.png" alt="" />
                <img class="rotate" src="../assets/images/play_2.png" alt="" />
                <img class="play" src="../assets/images/play_3.png" alt="" />
              </div>
              <div class="store" :class="{ 'store-kf': active_index === 0 }">
                <div id="googleplay-1">
                  <img @click="goLink('google')" src="../assets/images/google_play_1.png" alt="" />
                </div>
                <div id="onestore-1">
                  <img @click="goLink('store')" src="../assets/images/one_store_1.png" alt="" />
                </div>
              </div>
              <div id="btn-join-1" @click="goLink('google')" :class="{ 'btn-join-kf': active_index === 0 }">
                <img src="../assets/images/btn_join.png" alt="" />
              </div>
            </div>
            <div class="next">
              <img @click="next(1)" src="../assets/images/next.gif" alt="" />
            </div>
          </div>
          <div class="mask" v-show="isShowVideo">
            <div class="video">
              <div class="close" @click="closeVideo"></div>
              <video
                src="../assets/images/ab.mp4"
                controls="controls"
                autoplay
                muted
                preload
                loop
                x5-video-player-fullscreen="true"
                x5-playsinline
                playsinline
                webkit-playsinline
                width="100%"
                height="100%"
              ></video>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="section">
        <div class="bg bg-2">
          <div class="content">
            <div class="step-1">
              <div class="step-header">
                <img src="../assets/images/m/m_step1.png" alt="" />
              </div>
              <div class="step-content">
                <div class="gift">
                  <img class="rotate" src="../assets/images/rotate.png" alt="" />
                  <img class="box-1" src="../assets/images/step_1_gift_box_1.gif" alt="" />
                  <img class="box-2" src="../assets/images/step_1_gift_box_2.png" alt="" />
                  <img class="text" src="../assets/images/step_1_gift_text.png" alt="" />
                  <img class="point" src="../assets/images/point.png" alt="" />
                  <img class="rotate-decorate" src="../assets/images/rotate-bg.png" alt="" />
                </div>
                <div class="subscribe">
                  <div class="phone">
                    <span>010-</span>
                    <input
                      placeholder="숫자만 입력하세요"
                      oninput="if(value.length>8)value=value.slice(0,8)"
                      type="number"
                      v-model="params.mobile"
                    />
                    <div id="btn-summit" @click="subscribe">확인</div>
                  </div>
                  <div class="tip">
                    <div class="check-item">
                      <input type="checkbox" @change="tipCheckChange" v-model="tip[1]" />
                      <span>아래의 내용을 확인하였으며, 모두 동의합니다.</span>
                    </div>
                    <div class="check-item">
                      <input type="checkbox" v-model="tip[2]" />
                      <span> <a @click="goLink('detail')">개인 정보 수집 및 이용</a>에 동의합니다. (필수)</span>
                    </div>
                    <div class="check-item">
                      <input type="checkbox" v-model="tip[3]" />
                      <span>SMS를 통해 광고 정보 수신에 동의합니다. (필수)</span>
                    </div>
                    <div class="tip-item">* 전화번호당 일회만 참여 가능합니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="step-2">
              <div class="step-header">
                <img src="../assets/images/m/m_step2.png" alt="" />
              </div>
              <div class="step-content">
                <img class="gift" src="../assets/images/m/m_step_2_gift.png" alt="" />
                <div class="store">
                  <img class="text" v-if="!isMobile" src="../assets/images/text_2.png" alt="" />
                  <div class="store-btn">
                    <div id="googleplay-2">
                      <img @click="goLink('google')" src="../assets/images/google_play_1.png" alt="" />
                    </div>
                    <div id="onestore-2">
                      <img @click="goLink('store')" src="../assets/images/one_store_1.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="section">
        <div class="bg bg-3">
          <div class="content">
            <Lottery
              :class="{ 'lottery-kf': active_index === 2 }"
              :params="lotteryParams"
              :time="lottery_time"
              @lottery="lottery"
            ></Lottery>
            <div class="rule" :class="{ 'rule-kf': active_index === 2 }">
              <div class="num">남은 추첨 횟수: {{ lottery_time }}</div>
              <a class="activity" @click="isShowRotateMatters = true">주의사항</a>
            </div>
            <div id="btn-join-3" @click="goSubscribe" :class="{ 'btn-join-kf': active_index === 2 }">
              <img src="../assets/images/btn_join.png" alt="" />
            </div>
            <div class="footer-3" :class="{ 'footer-3-kf': active_index === 2 }">
              게임 론칭 후, SMS의 형식으로 쿠폰코드를 지급합니다.
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="section">
        <div class="bg bg-4">
          <div class="content">
            <div class="section-title" :class="{ 'title-kf': active_index === 3 }">
              <img src="../assets/images/title_4.png" alt="" />
            </div>
            <div v-if="!isMobile" class="gift">
              <div class="gift-item" :class="{ 'gift-kf-1': active_index === 3 }">
                <img src="../assets/images/gift_1.png" alt="" />
                <img class="icon" src="../assets/images/gift_bg.png" alt="" />
              </div>
              <div class="gift-item" :class="{ 'gift-kf-2': active_index === 3 }">
                <img src="../assets/images/gift_2.png" alt="" />
                <img class="icon" src="../assets/images/gift_bg.png" alt="" />
              </div>
              <div class="gift-item" :class="{ 'gift-kf-3': active_index === 3 }">
                <img src="../assets/images/gift_3.png" alt="" />
                <img class="icon" src="../assets/images/gift_bg.png" alt="" />
              </div>
              <div class="gift-item" :class="{ 'gift-kf-4': active_index === 3 }">
                <img src="../assets/images/gift_4.png" alt="" />
                <img class="icon" src="../assets/images/gift_bg.png" alt="" />
              </div>
              <div class="gift-item" :class="{ 'gift-kf-5': active_index === 3 }">
                <img src="../assets/images/gift_5.png" alt="" />
                <img class="icon" src="../assets/images/gift_bg.png" alt="" />
              </div>
            </div>
            <div v-if="isMobile" class="gift">
              <div :class="{ 'gift-kf-1': active_index === 3 }">
                <div class="gift-item">
                  <img src="../assets/images/gift_1.png" alt="" />
                  <img class="icon" src="../assets/images/gift_bg.png" alt="" />
                </div>
                <div class="gift-item">
                  <img src="../assets/images/gift_2.png" alt="" />
                  <img class="icon" src="../assets/images/gift_bg.png" alt="" />
                </div>
              </div>
              <div :class="{ 'gift-kf-2': active_index === 3 }">
                <div class="gift-item">
                  <img src="../assets/images/gift_3.png" alt="" />
                  <img class="icon" src="../assets/images/gift_bg.png" alt="" />
                </div>
                <div class="gift-item">
                  <img src="../assets/images/gift_4.png" alt="" />
                  <img class="icon" src="../assets/images/gift_bg.png" alt="" />
                </div>
                <div class="gift-item">
                  <img src="../assets/images/gift_5.png" alt="" />
                  <img class="icon" src="../assets/images/gift_bg.png" alt="" />
                </div>
              </div>
            </div>
            <div class="footer-4" :class="{ 'footer-4-kf': active_index === 3 }">
              <span class="item">* 정식 론칭 7일 후 우편으로 보상을 지급합니다. </span>
              <span class="item">* 이벤트 내용은 상황에 따라 변경될 수 있습니다.</span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="section">
        <div class="bg bg-4-2">
          <div class="content">
            <div class="content-flex">
              <div class="title">
                <img :class="{ 'title-kf': active_index === 1 }" src="../assets/images/title_onestore.png" alt="" />
                <div
                  v-if="!isMobile"
                  id="btn-onestore"
                  :class="{ 'btn-onestore-kf': active_index === 1 }"
                  @click="goLink('store')"
                >
                  <img src="../assets/images/btn_onestore.png" alt="" />
                </div>
              </div>
              <div :class="{ 'role-kf': active_index === 1 }" class="role">
                <img src="../assets/images/role_onestore.png" alt="" />
              </div>
            </div>
            <div
              v-if="isMobile"
              id="btn-onestore"
              :class="{ 'btn-onestore-kf': active_index === 1 }"
              @click="goLink('store')"
            >
              <img src="../assets/images/btn_onestore.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="bg bg-5">
          <div class="content">
            <div class="logo">
              <img v-if="!isMobile" src="../assets/images/profession.png" alt="" />
              <img v-if="isMobile" src="../assets/images/m/m_profession.png" alt="" />
            </div>
            <div v-for="item in 6" :key="item">
              <div class="name" :class="{ 'name-kf': active_role_index === 0 }" v-show="active_role_index === 0">
                <img v-if="!isMobile" src="../assets/images/role_1_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_1_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 0 }" v-show="active_role_index === 0">
                <img src="../assets/images/role_1.png" alt="" />
              </div>

              <div class="name" :class="{ 'name-kf': active_role_index === 1 }" v-show="active_role_index === 1">
                <img v-if="!isMobile" src="../assets/images/role_2_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_2_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 1 }" v-show="active_role_index === 1">
                <img src="../assets/images/role_2.png" alt="" />
              </div>

              <div class="name" :class="{ 'name-kf': active_role_index === 2 }" v-show="active_role_index === 2">
                <img v-if="!isMobile" src="../assets/images/role_3_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_3_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 2 }" v-show="active_role_index === 2">
                <img src="../assets/images/role_3.png" alt="" />
              </div>

              <div class="name" :class="{ 'name-kf': active_role_index === 3 }" v-show="active_role_index === 3">
                <img v-if="!isMobile" src="../assets/images/role_4_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_4_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 3 }" v-show="active_role_index === 3">
                <img src="../assets/images/role_4.png" alt="" />
              </div>

              <div class="name" :class="{ 'name-kf': active_role_index === 4 }" v-show="active_role_index === 4">
                <img v-if="!isMobile" src="../assets/images/role_5_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_5_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 4 }" v-show="active_role_index === 4">
                <img src="../assets/images/role_5.png" alt="" />
              </div>

              <div class="name" :class="{ 'name-kf': active_role_index === 5 }" v-show="active_role_index === 5">
                <img v-if="!isMobile" src="../assets/images/role_6_name.png" alt="" />
                <img v-if="isMobile" src="../assets/images/m/m_role_6_name.png" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 5 }" v-show="active_role_index === 5">
                <img src="../assets/images/role_6.png" alt="" />
              </div>

              <!-- <div class="name" :class="{ 'name-kf': active_role_index === 0 }" v-show="index === active_role_index">
                <img v-if="!isMobile" src="require(`../assets/images/role_${index + 1}_name.png`)" alt="" />
                <img v-if="isMobile" src="require(`../assets/images/m/m_role_${index + 1}_name.png`)" alt="" />
              </div>
              <div class="role" :class="{ 'role-kf': active_role_index === 0 }" v-show="index === active_role_index">
                <img src="require(`../assets/images/role_${index + 1}.png`)" alt="" />
              </div> -->
            </div>
            <div class="arms">
              <div class="arms-item">
                <div v-for="(item, index) in 3" :key="item" @click="changeRole(index)">
                  <img
                    v-show="active_role_index !== index"
                    :src="require(`../assets/images/arms_${index + 1}_2.png`)"
                    alt=""
                  />
                  <img
                    v-show="active_role_index === index"
                    :src="require(`../assets/images/arms_${index + 1}_1.png`)"
                    alt=""
                  />
                </div>
              </div>
              <div class="arms-item">
                <div v-for="(item, index) in 3" :key="item" @click="changeRole(index + 3)">
                  <img
                    v-show="active_role_index !== index + 3"
                    :src="require(`../assets/images/arms_${index + 4}_2.png`)"
                    alt=""
                  />
                  <img
                    v-show="active_role_index === index + 3"
                    :src="require(`../assets/images/arms_${index + 4}_1.png`)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section m-footer">
        <div class="content">
          <div class="title">
            <img src="../assets/images/title.png" alt="" />
          </div>
          <div class="swiper-box">
            <div class="prev">
              <img src="../assets/images/prev.png" alt="" class="swiper-button" @click="clickPrev" />
            </div>
            <swiper ref="mySwiper" :options="isMobile ? m_swiperOptions : pc_swiperOptions">
              <swiper-slide class="swiper-slide" v-for="(item, index) in 6" :key="index">
                <img :src="require(`../assets/images/swiper_${index + 1}.png`)" alt="" />
              </swiper-slide>
            </swiper>
            <div class="next">
              <img src="../assets/images/next.png" alt="" class="swiper-button" @click="clickNext" />
            </div>
          </div>
          <div v-if="isMobile" class="footer">
            <div class="footer-content">
              <img src="../assets/images/footer.png" alt="" />
              <div>
                <span class="text">ⓒ 2022 Flamegames. All Rights Reserved</span>
                <a @click="goLink('footer')">개인정보처리방침</a>
              </div>
              <div class="email">이메일 주소: cs@flame-games.com</div>
            </div>
          </div>
        </div>
      </div>
      <div class="section footer" v-if="!isMobile">
        <div class="footer-content">
          <div class="rights">
            <img src="../assets/images/footer.png" alt="" />
            <span class="text">ⓒ 2022 Flamegames. All Rights Reserved</span>
            <a @click="goLink('footer')">개인정보처리방침</a>
          </div>
          <div class="email">이메일 주소: cs@flame-games.com</div>
        </div>
      </div>
    </full-page>
    <!-- <Dialog
      v-if="isShowDialog"
      :visible="isShowDialog"
      :type="type"
      :text_index="text_index"
      :mobile="lotteryPhone"
      :confirm="confirm"
      @close="isShowDialog = false"
      @ok="goLottery"
    ></Dialog> -->
    <Menu :visible="isShowMenu" :index="active_index" @close="goPage"></Menu>
    <!-- <Matters :visible="isShowRotateMatters" @close="isShowRotateMatters = false"></Matters> -->
  </div>
</template>

<script>
// import Dialog from '../components/dialog/Dialog.vue'
import Menu from './Menu.vue'
// import Lottery from '../components/Lottery.vue'
// import Matters from './Matters.vue'
// import { summitSubscribe } from '../global/api/api'
import { analysis } from '../global/js/analysis'
export default {
  name: 'Index',
  components: {
    // Dialog,
    Menu
    // Lottery,
    // Matters
  },
  data() {
    return {
      // lotteryPhone: '', // 中奖手机号
      // isSubscribe: false, // 是否预约
      // lottery_time: 0, // 剩余抽奖次数
      isShowSubNav: false, // 是否显示子菜单
      isMobile: true, // 是否是移动端
      isShowMenu: false, // 是否显示移动端菜单
      isShowVideo: false, // 是否显示视频bo
      // isShowDialog: false, // 是否显示弹窗
      // isShowRotateMatters: false, // 是否显示注意事项
      // type: 1, // 弹窗类型
      // text_index: '', // 弹窗文本下标
      // confirm: false, // 弹窗是否有footer
      // isShowHeader: true, // 顶部导航显示
      // isUpSideNav: false, // 侧边store上移
      active_index: 0,
      active_role_index: '',
      link_list: {
        game: 'https://game.naver.com/lounge/REALM_OF_DEITY/home',
        ytbe: 'https://www.youtube.com/channel/UCkUeJmwt0vvwcWtuup67dVw',
        google: 'https://googleplay-kr.onelink.me/IpYd/website',
        store: 'https://onesto.re/0000764012',
        detail: 'https://op-static.hookylin.com/user-privacy.html',
        footer: 'https://op-static.hookylin.com/user-privacy.html'
      },
      options: {
        // autoScrolling: false,
        // section配置
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        //是否显示导航，默认为false
        // navigation: true,
        //为每个section设置背景色
        sectionsColor: ['#000', '#000', '#000', '#000', '#000', '#000', '#000', '#000'],
        // 控制动画出现
        onLeave: (index, nextIndex, direction) => {
          this.active_index = nextIndex.index
          if (this.active_index === 2) {
            this.active_role_index = 0
          } else {
            this.active_role_index = ''
          }
          // 动画效果js
          // if (this.active_index !== 0) {
          //   this.isShowHeader = false
          //   this.isUpSideNav = true
          // } else {
          //   this.isShowHeader = true
          //   this.isUpSideNav = false
          // }
        }
      },
      // 轮播图配置
      pc_swiperOptions: {
        autoplay: {
          delay: 3000, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 2,
        centeredSlides: true,
        // spaceBetween: '-20%',
        // spaceBetween: 10,
        // history: 'love',
        // 设置点击箭头
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        }
      },
      m_swiperOptions: {
        autoplay: {
          delay: 3500, //滚动时间间隔
          disableOnInteraction: false //不可用当用户触摸后，false代表失效
        },
        loop: true, //循环滚动
        navigation: {
          nextEl: '.next',
          prevEl: '.prev'
        }
      },
      deviceList: []
      // params: {
      //   game_id: 1, // 青云传
      //   mobile: ''
      // },
      // lotteryParams: {
      //   game_id: 1, // 青云传
      //   mobile: ''
      // },
      // tip: {
      //   1: true,
      //   2: true,
      //   3: true
      // }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  created() {
    this.isMobilePlat()
    // window.addEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    // window.addEventListener('pagehide', (e) => this.pagehideFn(e))
  },
  destroyed() {
    // window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    // window.removeEventListener('pagehide', (e) => this.pagehideFn(e))
  },
  methods: {
    /**抽奖 */
    // lottery(data) {
    //   if (data.status) {
    //     this.lottery_time = 0
    //     this.lotteryPhone = '010' + this.lotteryParams.mobile
    //     console.log('this.lotteryParams.mobile', this.lotteryParams.mobile)
    //     console.log('this.lotteryPhone', this.lotteryPhone)
    //   }
    //   this.setDialogParams(2, data.index)
    // },
    /** 监听页面刷新或者关闭提示 */
    // pc android端
    // beforeunloadFn(e) {
    //   // this.setDialogParams(1, 4, true)
    //   // e = e || window.event
    //   // // 兼容IE8和Firefox 4之前的版本
    //   if (e && this.lottery_time) {
    //     e.returnValue = '关闭提示'
    //   }
    //   // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
    //   // return '关闭提示'
    // },
    // ios移动端
    pagehideFn(e) {
      if (e) {
        e.returnValue = '关闭提示'
      }
    },
    /**第一个协议被勾中 */
    // tipCheckChange() {
    //   if (this.tip[1]) {
    //     this.tip[2] = true
    //     this.tip[3] = true
    //   }
    // },
    /**设置弹窗参数 */
    // setDialogParams(type, text_index, confirm) {
    //   this.type = type
    //   this.text_index = text_index
    //   this.isShowDialog = true
    //   if (confirm) {
    //     this.confirm = true
    //   } else {
    //     this.confirm = false
    //   }
    // },
    /**去抽奖 */
    // goLottery() {
    //   this.isShowDialog = false
    //   this.next(2)
    // },
    /**菜单跳转页面 */
    goPage(index) {
      console.log('index', index)
      this.active_index = index
      this.$refs.fullpage.api.moveTo(index + 1)
    },
    /**移动端显示菜单 */
    showMenu() {
      this.isShowMenu = !this.isShowMenu
    },
    /**判断是否是移动端 */
    isMobilePlat() {
      const width = document.body.clientWidth
      if (width <= 768) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
      console.log('this.isMobile', this.isMobile)
    },
    /**提交预约信息 */
    // async subscribe() {
    //   analysis(2)
    //   // 未勾选必选项目
    //   if (!this.tip[1] || !this.tip[2] || !this.tip[3]) {
    //     this.setDialogParams(1, 3)
    //     return
    //   }
    //   // 手机号格式不正确
    //   if (!this.params.mobile) {
    //     this.setDialogParams(1, 1)
    //     return
    //   }
    //   const params = JSON.parse(JSON.stringify(this.params))
    //   params.mobile = '82010' + params.mobile
    //   console.log('params', params)
    //   const res = await summitSubscribe(params).catch((err) => {
    //     // 手机号格式不正确
    //     if (err.code === 40001) {
    //       this.setDialogParams(1, 1)
    //       return
    //     }
    //   })
    //   if (res.code === 0) {
    //     this.lotteryParams = this.params
    //     console.log('this.lotteryParams', this.lotteryParams)
    //     if (res.data.is_new) {
    //       // 恭喜您预约成功，获得一次抽奖机会
    //       this.setDialogParams(1, 0)
    //       this.lottery_time = res.data.chance
    //       return
    //     } else {
    //       // 该手机号已预约，不可重复预约
    //       this.setDialogParams(1, 2)
    //       this.lottery_time = res.data.chance
    //       return
    //     }
    //   } else {
    //     console.log(res.msg)
    //   }
    // },
    /**视频播放与关闭 */
    playVideo() {
      analysis(4)
      this.isShowVideo = true
    },
    closeVideo() {
      this.isShowVideo = false
    },
    goSubscribe() {
      this.next(1)
    },
    /**跳转链接 */
    goLink(key) {
      if (key === 'google') {
        analysis(0)
      } else if (key === 'store') {
        analysis(1)
      }
      window.open(this.link_list[key], '_blank')
    },
    /**角色切换 */
    changeRole(index) {
      this.active_role_index = index
    },
    /**显示子菜单 */
    showSideNav() {
      this.isShowSubNav = true
    },
    /**页面切换 */
    next(index) {
      // 向下滚动一页
      this.active_index = index
      this.$refs.fullpage.api.moveTo(index + 1)
    },
    /**鼠标移至顶部触发导航显示 */
    // headerHover() {
    //   if (this.active_index !== 0) {
    //     this.isShowHeader = true
    //   }
    // },
    /**鼠标离开顶部触发导航消失 */
    // headerLeave() {
    //   if (this.active_index !== 0) {
    //     this.isShowHeader = false
    //   }
    // },
    /* 前一步 */
    clickPrev() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn <= 0 || length == 0) {
        return false
      }
    },
    /* 后一步 */
    clickNext() {
      const that = this
      const length = that.deviceList.length
      if (that.activeBtn >= length - 1 || length == 0) {
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/css/keyframes.less';
.page {
  position: relative;
  width: 100wv;
  height: 100vh;
}
/* PC端 */
@media screen and (min-width: 769px) {
  @import '../assets/css/pc.less';
}

/* 移动端  */
@media screen and (max-width: 769px) {
  @import '../assets/css/m.less';
}
</style>
